export { default } from "./Title.js";
